/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import Button, { ButtonContainer } from 'components/Button/index';
import React, { useState, useEffect, useRef } from 'react';

import {
  Dialog,
  DialogBody,
  ContentTextarea,
  DialogCancel,
  DialogConfirm,
} from './styles';

export default function ModalContacts({
  show,
  onModalClose,
  onConfirm,
  confirmAndClose = true,
  onlyConfirmation = false,
  small = false,
  ...props
}) {
  const [visible, setVisible] = useState(show);
  const myRef = useRef();

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const handleConfirm = () => {
    onConfirm && onConfirm()
    if (confirmAndClose)
      onModalClose && onModalClose()
  }

  return (
    <Dialog canShow={visible} >
      <DialogBody small={small} ref={myRef}>
        <ContentTextarea>
          {props.children}
          <br />
          <ButtonContainer style={{ justifyContent: 'flex-end' }}>
            {!onlyConfirmation &&
              <Button
                secundary
                style={{ marginLeft: "5px", marginRight: '5px', marginBottom: '5px', maxWidth: '200px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onModalClose()
                }}>CANCEL
              </Button>
            }

            <Button
              style={{ marginLeft: "5px", marginRight: '5px', marginBottom: '5px', maxWidth: '200px' }}
              primary
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleConfirm();
              }}>{onlyConfirmation ? 'OK' : 'CONFIRM'}
            </Button>
          </ButtonContainer>
        </ContentTextarea>
      </DialogBody>
    </Dialog>
  );
}